export enum SimCapCodes {
  ZERO_DEFAULT = 1,
}
